import { Component, OnInit } from '@angular/core';
import { FormulaireService } from '../formulaire.service';
import { SaisieCanDeactivate } from '../can-deactivate/saisie-can-deactivate/saisie-can-deactivate';

/**
 * Ce composant permet d’afficher la saisie en cours ou le tableau de synthèse.
 * Tout en gérant l’alerte si le questionnaire possède des modifications non enregistrées.
 */
@Component({
  selector: 'bis-formulaire',
  template: '<router-outlet></router-outlet>'
})
export class FormulaireComponent extends SaisieCanDeactivate implements OnInit {

  constructor(
    private formulaireService: FormulaireService,
  ) {
    super();
   }

  ngOnInit() {
  }

  get modificationEnCours(): boolean {
    return this.formulaireService.modificationEnCours;
  }


}
